import useYearsLastPeriod from "backend/hooks/model/useYearsLastPeriod";
import { ICardElementWithChildren } from "backend/model/model";
import React from "react";
import DomElement from "reportengine/DomElement";

//   const lastPeriod = useYearsLastPeriod(ctx.period || "");

const LastPeriodsName = (
  props: React.PropsWithChildren<{
    item: ICardElementWithChildren;
    slideElement: string;
  }>
) => {
  const lastPeriod = useYearsLastPeriod(props.item.period?.name || "");

  return (
    <DomElement
      slideElement={props.slideElement}
      selector=".txt"
      typename="text"
    >
      {lastPeriod ? (
        <div className="txt"> Year End Target • {lastPeriod.name}</div>
      ) : null}
    </DomElement>
  );
};

export default LastPeriodsName;
